import { Component, Input, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faUser } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DirectoryEditingBehaviourState } from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/directory-behaviour/directory-editing/directory-editing-behaviour.state';
import { RestoreWindow, SetWindowIndex } from 'src/app/store/utility/samweb-window/samweb-window.actions';
import { SamwebWindowState, WindowType, WindowTypes } from 'src/app/store/utility/samweb-window/samweb-window.state';
import { DirectoryEntryRemoteDto } from 'src/generated/swagger';

@Component({
   selector: 'samweb-directory-editing-item',
   templateUrl: './directory-editing-item.component.html',
   styleUrls: ['./directory-editing-item.component.scss'],
})
export class DirectoryEditingItemComponent implements OnInit {
   @Input()
   public entry: DirectoryEntryRemoteDto;

   public type: WindowType = WindowTypes.Directory;

   public directoryIcon: IconDefinition = faUser;

   public title = '';

   public isNameEmpty = false;
   public isNumberEmpty = false;

   public areEditableEntriesChanged$: Observable<boolean>;
   constructor(public store: Store) {}

   ngOnInit(): void {
      this.title =
         this.entry.id < 0
            ? 'brick.brick_definitions.directory_browser.add_contact_details.title'
            : 'brick.brick_definitions.directory_browser.edit_contact_details.title';

      this.isNameEmpty = _.isEmpty(this.entry?.orgnam);
      this.isNumberEmpty = _.isEmpty(this.entry?.orgnum);

      this.areEditableEntriesChanged$ = this.store
         .select(DirectoryEditingBehaviourState.areEditableEntriesChanged)
         .pipe(map((areEntriesChanged) => areEntriesChanged(this.entry.id)));
   }

   onClick() {
      const index = this.store.selectSnapshot(SamwebWindowState.getHighestIndex);
      this.store.dispatch(new SetWindowIndex(this.type, this.entry.id.toString(), index + 1));
      this.store.dispatch(new RestoreWindow(this.type, this.entry.id.toString()));
   }
}
